var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasaEsqueleticaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.723,
    height: 18.787,
    viewBox: "0 0 18.723 18.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12774",
    "data-name": "Group 12774",
    transform: "translate(0.502 0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    "data-name": "Path 7332",
    d: "M5412.085,378.2a2.71,2.71,0,0,1,2.425,2.077,2.644,2.644,0,0,1-.942,2.907,2.721,2.721,0,0,1-3.238.223l-5.763,5.546a2.817,2.817,0,0,1-.25,3.552,2.621,2.621,0,0,1-2.91.77,2.766,2.766,0,0,1-1.957-2.391c-.152-.035-.322-.067-.489-.113a2.805,2.805,0,0,1,.244-5.46,2.7,2.7,0,0,1,1.883.309.229.229,0,0,0,.334-.046q2.08-2.092,4.168-4.176c.409-.411.8-.841,1.207-1.252.105-.106.09-.178.027-.294a2.812,2.812,0,0,1,3.8-3.85,2.676,2.676,0,0,1,1.4,1.98C5412.044,378.06,5412.067,378.134,5412.085,378.2ZM5400.6,390.548a1.663,1.663,0,0,0,2.5,1.524,1.69,1.69,0,0,0,.425-2.57c-.327-.4-.317-.624.035-.983.776-.792,1.546-1.59,2.327-2.377q1.9-1.915,3.816-3.818c.372-.372.6-.386,1-.048a1.685,1.685,0,0,0,2.764-1.55,1.69,1.69,0,0,0-1.748-1.4c-.616.037-.793-.163-.757-.769a1.7,1.7,0,0,0-2.084-1.726,1.67,1.67,0,0,0-.858,2.758.6.6,0,0,1-.029.947c-.956.974-1.908,1.951-2.869,2.92-1.068,1.077-2.144,2.146-3.217,3.219-.464.464-.631.474-1.141.069a1.68,1.68,0,0,0-2.614,1.913,1.689,1.689,0,0,0,1.748,1.092c.342-.031.571.08.657.352A2.222,2.222,0,0,1,5400.6,390.548Z",
    transform: "translate(-5396.909 -375.658)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasaEsqueleticaImage);
export default __webpack_public_path__ + "static/media/masa_esqueletica_image.bc17f250fd9a6a7bcbbd2b370cc3d98d.svg";
export { ForwardRef as ReactComponent };